var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AVALANCHE_MAINNET_PARAMS, AVALANCHE_TESTNET_PARAMS, BINANCE_MAINNET_PARAMS, } from "../constants/chainParameters";
import { isAvaxNetwork, isBinanceNetwork } from "../constants/constants";
import { CHAINID } from "./env";
// This error code indicates that
var ChainCodeErrorEnum;
(function (ChainCodeErrorEnum) {
    ChainCodeErrorEnum[ChainCodeErrorEnum["UNAVAILABLE"] = 4902] = "UNAVAILABLE";
    ChainCodeErrorEnum[ChainCodeErrorEnum["CANCELLED"] = 4001] = "CANCELLED";
})(ChainCodeErrorEnum || (ChainCodeErrorEnum = {}));
/**
 * Function copied and modified from https://docs.metamask.io/guide/rpc-api.html#other-rpc-methods
 * error code 4902 refers to chain being available in the wallet
 */
export var switchChains = function (provider, chainId) { return __awaiter(void 0, void 0, void 0, function () {
    var hexChainId, switchError_1, params, addError_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hexChainId = "0x" + chainId.toString(16);
                if (!provider.provider.request)
                    return [2 /*return*/];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 10]);
                return [4 /*yield*/, provider.provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [{ chainId: hexChainId }],
                    })];
            case 2:
                _a.sent();
                return [3 /*break*/, 10];
            case 3:
                switchError_1 = _a.sent();
                if (switchError_1.code === ChainCodeErrorEnum.CANCELLED) {
                    window.location.reload();
                }
                if (!(switchError_1.code === ChainCodeErrorEnum.UNAVAILABLE ||
                    (switchError_1.data &&
                        switchError_1.data.originalError &&
                        switchError_1.data.originalError.code === ChainCodeErrorEnum.UNAVAILABLE))) return [3 /*break*/, 9];
                params = void 0;
                if (isAvaxNetwork(chainId)) {
                    params =
                        chainId === CHAINID.AVAX_MAINNET
                            ? AVALANCHE_MAINNET_PARAMS
                            : AVALANCHE_TESTNET_PARAMS;
                }
                if (isBinanceNetwork(chainId)) {
                    params = BINANCE_MAINNET_PARAMS;
                }
                if (!params) return [3 /*break*/, 8];
                _a.label = 4;
            case 4:
                _a.trys.push([4, 6, , 7]);
                return [4 /*yield*/, provider.provider.request({
                        method: "wallet_addEthereumChain",
                        params: [params],
                    })];
            case 5:
                _a.sent();
                return [3 /*break*/, 7];
            case 6:
                addError_1 = _a.sent();
                // handle "add" error
                console.error("Add network error"); // eslint-disable-line
                return [3 /*break*/, 7];
            case 7: return [3 /*break*/, 9];
            case 8: throw new Error("Network not found");
            case 9: return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=chainSwitching.js.map